import React from 'react';
import validator from 'validator';
import {Button, UncontrolledAlert} from 'reactstrap';
import Spinner from 'react-spinkit';
import AppColors from '../../common/Colors';
import Utils from "../../common/Utils";
import {UsersEndpoints} from "../../common/ProxyEndpoints";
import AppVariables from "../../common/AppVariables";
import TTLProxy from "../../common/TTLAsyncProxy";
import SessionStateManager from "../../common/SessionStateManager";
import LogoHeader from '../../components/LogoHeader/LogoHeader';
import PlatformRender from "../../components/PlatformRender/PlatformRender";
import {DevicePlatforms} from "../../common/Constants";
import DocumentTitle from 'react-document-title';
import CodeInputView from "../../components/CodeInputView/CodeInputView";
import {Form, Formik} from "formik";
import * as yup from 'yup';
import FormInput from "../../components/FormInput";

const resetValidationSchema = yup.object().shape({
    resetToken: yup.string().required().min(Math.max(AppVariables.SmsTokenLength,AppVariables.EmailTokenLength)).label("Reset code"),
    password: yup.string().required().min(6).max(128).label("Password"),
    confirmPassword: yup.string().required().min(6).max(128).label("Confirmation password")
        .oneOf([yup.ref("password"),null], "Passwords do not match")
});

const ResetPhase = Object.freeze({
    EnterEmail: 0,
    EnterResetCode: 1,
    Complete: 2,
});

export  default class ForgotPassword extends React.Component {

    constructor(props) {
        super(props);

        //  get proxy reference
        this.proxy = TTLProxy.getInstance();

        //
        const session = new SessionStateManager("forgot_password",true);

        this.state = {
            isBusy : false,
            phase: session.getState("phase",ResetPhase.EnterEmail) ,
            passwordsMatch: session.getState("passwordsMatch",false),
            userEmail : session.getState('userEmail',null),
            resetState: session.getState('resetState',{}),
            userIdentityToken: session.getState("userIdentityToken",null),
            warnMessage: null,
            errorMessage: null,
            tipMessage: null,
        };

        this.session = session;
    }

    onNavigateToLink(link,evt){
        this.session.reset();
        Utils.navigateLink(link,evt);
    }


    validateInputs(){

        let email = this._email;
        if(!validator.isEmail(email.value) && !Utils.validatePhoneNumber(email.value) && validator.isEmpty(email.value)){
            Utils.flashInput(email);
            return false;
        }

        return true;
    }


    onSubmitForgot(evt){

        evt.preventDefault();

        //  we can't submit with busy state or invalid input
        if(this.state.isBusy || !this.validateInputs()){
            return;
        }

        //  get the email of the user
        let email = this._email;

        //  send reset token
        this.sendResetToken(email.value,ResetPhase.EnterResetCode).then(success => {

            if(success)
                email.value = null;

            Utils.flashInput(email);
        });

    }

    sendResetToken(email , nextPhase) {

        const proxy = this.proxy;
        const me = this;

        //  set busy state
        this.setState({
            isBusy: true,
            errorMessage: null,
            userEmail : email
        });

        return proxy.processRequest(UsersEndpoints.forgotPassword(email)).then((response) => {

            if(response.ok) {

                const body = response.body;

                //  check status
                me.setState({
                    isBusy: false,
                    phase: nextPhase || me.state.phase,
                    userIdentityToken: body.identity,
                    errorMessage: null,
                    warnMessage: null,
                    tipMessage: "Reset code has been sent successfully!",
                });

            }

            return response.ok;

        }).catch((err) => {

            this.setState({ isBusy: false });

            //
            if('isConnectionError' in err && err.isConnectionError()){

                me.setState({
                    errorMessage: "Network error. Please check your internet connection and try again!",
                    warnMessage: null,
                    tipMessage: null
                });

                return false;
            }

            //
            const response = err.response;
            if(response && response.status == 403){

                me.setState({
                    warnMessage: null,
                    errorMessage: Utils.getResponseError(err),
                    tipMessage: null
                });

                return false;
            }

            me.setState({
                phase: nextPhase || me.state.phase,
                tipMessage: null
            });

            return true;
        });

    }

    onInputChanged(evt){

        if(this.state.errorMessage != null && this.state.lastErrorInput == evt.target){
            this.setState({
                errorMessage: null
            });
        }
    }

    renderBottomFrame(){

        return  (<div className={'clearfix'} style={{'marginTop' : '10px'}}>
            {this.state.isBusy ? <Spinner name="ball-beat" color="green"  className="pull-right"/>  : null}
            <a href="#" className={"pull-left"} onClick={this.onNavigateToLink.bind(this,'/login')}><i className="icon-arrow-left"></i><b> Back to login</b></a>
        </div>);
    }

    renderEnterEmail(errorSection){

        const state = this.state;

        return (<form className="card-block" onSubmit={this.onSubmitForgot.bind(this)}>

            <div className="text-center">

                <PlatformRender platform={DevicePlatforms.Desktop}>
                    <h1>Forgot Password</h1>
                </PlatformRender>

                <PlatformRender platform={DevicePlatforms.Mobile}>
                    <h4>Forgot Password</h4>
                </PlatformRender>

            <p>Recover your lost password. Enter your email or phone number below</p>

            <div className="input-group mb-3">
                <span className="input-group-addon"><i className="icon-user"></i></span>
                <input type="text" key="user-input" className="form-control form-input-addon"
                       id="email" name="email"
                       placeholder="Enter your email or phone number here..."
                       ref={r => this._email = r}
                       disabled={state.isBusy}
                       onChange={this.onInputChanged.bind(this)}/>
            </div>
            {state.isBusy && <p className="text-center">Processing password reset, please be patient...</p>}
            {errorSection && (
                <div className="input-group">
                    {errorSection}
                </div>)
            }

            <div className="input-group">
                <Button block color="green" type="submit"
                        disabled={state.isBusy}>Reset Password</Button>
            </div>

            {this.renderBottomFrame()}

            </div>

        </form>);
    }

    onReset({ resetToken , confirmPassword, password }){

        const state = this.state;
        const me = this;

        //  set busy state
        this.setState({
            isBusy: true,
            errorMessage: null
        });

        //  get proxy reference
        const proxy = this.proxy;

        //
        return proxy.processRequest(UsersEndpoints.completePasswordReset(this.state.userIdentityToken,resetToken,password)).then((response) =>{

            if(response.ok){

                //  complete phase
                me.setState({
                    isBusy: false,
                    phase: ResetPhase.Complete
                });

            }
            else{

                //  unexpected error
                me.setState({
                    isBusy: false,
                    errorMessage: "Something went wrong. Please try again!"
                });

            }

        }).catch((err) => {

          me.setState({
                isBusy: false,
                errorMessage: Utils.getResponseError(err)
            });

        });

    }

    renderReset(errorSection){

        return <Formik
            ref={r => this._resetForm = r}
            validationSchema={resetValidationSchema}
            onSubmit={async (values,{ setSubmitting }) => {

                try{
                   await this.onReset(values);
                }
                catch (e) {

                }
                finally {
                    setSubmitting(false);
                }

            }}
            initialValues={{
                resetToken: '',
                password: '',
                confirmPassword: '',
                ...this.state.resetState
            }}>

            {({ isValid , isSubmitting, values }) => {

                const hasValidResetCode = () => {

                    try {
                        resetValidationSchema.validateSyncAt('resetToken',values,{ abortEarly: true });
                        return true;
                    }
                    catch (e) {
                        return false;
                    }
                };

                return (<Form className="card-block form-horizontal">
                    <div className="text-center">

                        <PlatformRender platform={DevicePlatforms.Desktop}>
                            <h1>Forgot Password</h1>
                        </PlatformRender>

                        <PlatformRender platform={DevicePlatforms.Mobile}>
                            <h4>Forgot Password</h4>
                        </PlatformRender>

                        <p>You've been sent a password reset token. Kindly check and supply the reset code.<br/> Click <a href="#" className="btn-link" onClick={(evt) =>{
                            evt.preventDefault();
                            this.sendResetToken(this.state.userEmail);
                        }}>here</a> to resend token.</p>

                        {this.state.warnMessage && <UncontrolledAlert color={"warning"}>{this.state.warnMessage}</UncontrolledAlert>}
                        {this.state.tipMessage && <UncontrolledAlert color={"info"} >{this.state.tipMessage}</UncontrolledAlert>}

                        <div className="mb-3">
                            <CodeInputView name="resetToken" size={0.8} minWidth={null}/>
                        </div>

                        {hasValidResetCode() && <div className="animated fadeIn">
                            <hr/>

                            <h4>One more step to go...</h4>
                            <br/>

                            <div className="text-left">

                            <FormInput type="password"
                                       name="password"
                                       title="New Password"
                                       icon="fa fa-lock"
                                       placeholder="Enter new password here"
                                       required
                                       disabled={isSubmitting}/>

                            <FormInput type="password"
                                       name="confirmPassword"
                                       title="Confirm Password"
                                       icon="fa fa-lock"
                                       placeholder="Confirm new password..."
                                       required
                                       disabled={isSubmitting}/>

                            </div>

                        </div>}

                        {errorSection && (
                            <div className="input-group">
                                {errorSection}
                            </div>)
                        }

                        <div className="input-group">
                            <Button block color="green" type="submit"
                                    disabled={!isValid}>
                                 <i className="fa fa-check"/> Reset Password
                            </Button>
                        </div>

                        {this.renderBottomFrame()}

                    </div>


                </Form>)
            }}
        </Formik>;

    }

    renderComplete(){

        return (<div className="text-center">
            <img src="/img/password_reset.png" width={128} height={128} style={{ marginBottom: '10px' , marginTop : '10px' }}></img>
            <p>Password reset successfully!</p>
            <Button color="green" onClick={this.onNavigateToLink.bind(this,'/login')}>Back to Login</Button>
        </div>);

    }

    render() {

        const state = this.state;
        let errorSection = state.errorMessage !== null ? <p className="error-label">{state.errorMessage}</p> : null;
        const phase = state.phase;

        let content;
        switch (phase){
            case ResetPhase.Complete:
                content = this.renderComplete(errorSection);
                break;
            case ResetPhase.EnterResetCode:
                content  = this.renderReset(errorSection);
                break;
            case ResetPhase.EnterEmail:
                content = this.renderEnterEmail(errorSection);
                break;
        }

        return (<DocumentTitle title={"Reset Password"}>

                <React.Fragment>

                    <PlatformRender platform={DevicePlatforms.Desktop}>
                        <div className="app flex-row align-items-center" style={{backgroundColor: AppColors.PageBackgroundColor }}>
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-md-8">
                                        <div className="card-group mb-0">
                                            <div className="card p-4 login-form animated fadeIn">
                                                <LogoHeader />
                                                {content}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </PlatformRender>

                    <PlatformRender platform={DevicePlatforms.Mobile} onActivate={() => { window.document.body.style.backgroundColor = AppColors.PageWhiteBgColor }} onDeactivate={() => { window.document.body.style.backgroundColor = this._bodyColor }}>
                        <div style={{ width: '100%' }}>
                            <LogoHeader style={{padding: 17 , paddingBottom: 0}}/>
                            {content}
                        </div>
                    </PlatformRender>

                </React.Fragment>
            </DocumentTitle>);
    }



}


// WEBPACK FOOTER //
// ./src/views/ForgotPassword/ForgotPassword.js